<div id="showcase">
    <div class="carousel slide text-center" id="slide1" data-ride="carousel">
        <!-- <ol class="carousel-indicators">
            <li class="active" data-target="#slide1"
            data-slide-to="0"></li>
            <li data-target="#slide1" data-slide-to="1" ></li>
            <li data-target="#slide1" data-slide-to="2"></li>
            <li data-target="#slide1" data-slide-to="3"></li>
            <li data-target="#slide1" data-slide-to="4"></li>
            
        </ol> -->
        <div class="carousel-inner">
            <div class="carousel-item  ">
                <div class="container-fluid" id="loader" *ngIf="isLoading[0]">
                    <app-loader></app-loader>
                </div>
                <img  src="/assets/img/showcase/14.jpg" alt="School Bhilding" class="img-fluid "
                [ngStyle]="{visibility:isLoading[0]?'hidden':'visible'}"
                (load)="hideLoader(0)" (error)="hideLoader(0)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>Preparation  &nbsp;is  &nbsp;the  &nbsp;key  &nbsp;to  &nbsp;success.</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item active">
                <div class="container-fluid" id="loader" *ngIf="isLoading[1]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/13.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[1]?'hidden':'visible'}"
                (load)="hideLoader(1)" (error)="hideLoader(1)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@SPREADING  &nbsp; A  &nbsp; SMILE</h1>
                    <!-- <h1>@TO  &nbsp; TEACH  &nbsp; IS &nbsp;TO &nbsp; LEARN &nbsp;TWICE  </h1> -->
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[2]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/3.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[2]?'hidden':'visible'}"
                (load)="hideLoader(2)" (error)="hideLoader(2)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <!-- <h1>@SPREADING  &nbsp; A  &nbsp; SMILE</h1> -->
                    <h1>@INDEPENDENCE  &nbsp; DAY  &nbsp; CELEBRATION</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[3]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/4.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[3]?'hidden':'visible'}"
                (load)="hideLoader(3)" (error)="hideLoader(3)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@CRAFT &nbsp; TIME</h1>
                    <!-- <h1>@SUCCESS  &nbsp; IS  &nbsp; THE &nbsp; SUM &nbsp; OF</h1>
                    <h1>SMALL  &nbsp; EFFORTS,  &nbsp; REPEATED</h1> -->
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[4]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/5.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[4]?'hidden':'visible'}"
                (load)="hideLoader(4)" (error)="hideLoader(4)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@WORD &nbsp; OF &nbsp; THE &nbsp; DAY</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[5]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/6.jpeg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[5]?'hidden':'visible'}"
                (load)="hideLoader(5)" (error)="hideLoader(5)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@PLAY</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[6]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/7.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[6]?'hidden':'visible'}"
                (load)="hideLoader(6)" (error)="hideLoader(6)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@SUCCESS  &nbsp; IS  &nbsp; THE &nbsp; SUM &nbsp; OF</h1>
                    <h1>SMALL  &nbsp; EFFORTS,  &nbsp; REPEATED</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>

            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[7]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/9.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[7]?'hidden':'visible'}"
                (load)="hideLoader(7)" (error)="hideLoader(7)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@KARGIL  &nbsp; VIJAY  &nbsp; DIWAS</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[8]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/10.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[8]?'hidden':'visible'}"
                (load)="hideLoader(8)" (error)="hideLoader(8)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@KARGIL  &nbsp; VIJAY  &nbsp; DIWAS</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[9]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/11.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[9]?'hidden':'visible'}"
                (load)="hideLoader(9)" (error)="hideLoader(9)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@KARGIL  &nbsp; VIJAY  &nbsp; DIWAS</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            <div class="carousel-item">
                <div class="container-fluid" id="loader" *ngIf="isLoading[10]">
                    <app-loader></app-loader>
                </div>
                <img src="/assets/img/showcase/12.jpg" alt="School Logo" class="img-fluid "
                [ngStyle]="{visibility:isLoading[10]?'hidden':'visible'}"
                (load)="hideLoader(10)" (error)="hideLoader(10)">
                <div class="carousel-caption d-none d-md-block animate__animated animate__slideInDown">
                    <h1>@TEEJ  &nbsp; CELEBRATION</h1>
                    <h3>MAHARANA &nbsp;PRATAP&nbsp; PUBLIC &nbsp;SCHOOL</h3>
                  </div>
            </div>
            
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#slide1" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#slide1" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
    </div>
    <!-- <div class="box-cards d-none d-lg-block">
        <div class="container">
            <div class="row">
                <div class="col-4">
                    <div class="card" routerLink="/achievements/awards">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-3">
                                    <span><i class="bi bi-trophy"></i></span>
                                </div>
                                <div class="col-9">
                                    <h3 class="animate__animated animate__rubberBand">Awards &</h3>
                                    <h5 class="animate__animated animate__heartBeat">Scholarships</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="card" routerLink="/gallery">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-3">
                                    <span><i class="bi bi-images"></i></span>
                                </div>
                                <div class="col-9">
                                    <h3 class="animate__animated animate__rubberBand">Gallery</h3>
                                    <h5 class="animate__animated animate__heartBeat">Photos & Videos</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="card" routerLink="/achievements/cbse">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-3">
                                    <span><i class="bi bi-newspaper"></i></span>
                                </div>
                                <div class="col-9">
                                    <h3 class="animate__animated animate__rubberBand">CBSE </h3>
                                    <h5 class="animate__animated animate__heartBeat">Results</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>





